import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.807 13.042.75 18l3.75.75 1.5 4.5 3.944-6.258m9.249-3.95L23.25 18l-3.75.75-1.5 4.5-3.944-6.258"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 9a8.25 8.25 0 1 0 16.5 0 8.25 8.25 0 1 0-16.5 0"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m12.531 4.292 1.248 2.458h2.127a.582.582 0 0 1 .419 1l-1.953 1.918 1.082 2.485a.589.589 0 0 1-.839.737L12 11.419 9.385 12.89a.589.589 0 0 1-.839-.737l1.082-2.485-1.953-1.922a.582.582 0 0 1 .419-1h2.127l1.249-2.454a.6.6 0 0 1 1.061 0"
    }, null, -1)
  ]));
}
const interfaceFavoriteAward = { render };
export {
  interfaceFavoriteAward as default,
  render
};
//# sourceMappingURL=interface-favorite-award.svg.js.map
